export function useEnedisSitesMapModal() {
  const isOpen = useState('enedis-sites-map-modal.open', () => false)
  const pendingSitLib = useState<string | null>('enedis-sites-map-modal.pending-sit-lib', () => null)

  function open(): void {
    pendingSitLib.value = null
    isOpen.value = true
  }

  function openWithSite(sitLib: string): void {
    const normalizedSitLib = sitLib.trim()
    if (normalizedSitLib === '') {
      return
    }
    pendingSitLib.value = normalizedSitLib
    isOpen.value = true
  }

  function consumePendingSitLib(): string | null {
    const sitLib = pendingSitLib.value
    pendingSitLib.value = null
    return sitLib
  }

  return {
    isOpen,
    pendingSitLib,
    open,
    openWithSite,
    consumePendingSitLib,
  }
}
